import {
  Control,
  Controller,
  ControllerRenderProps,
  FieldErrors,
  FieldValues,
} from 'react-hook-form';

import { EssQuestion } from '@/domain/impact-ess/entities/question.entity';
import { FSTextField } from '@/ui/components/input/FSTextField';
import { language } from '@/ui/i18n';
import { isFactor } from '@/ui/utils/form-validations';

type Inputs = { [key: string]: string };

interface IProps {
  fields: EssQuestion['fields'];
  name: string;
  value: string;
  control: Control<FieldValues, any>; // eslint-disable-line
  onBlur: () => void;
  errors: FieldErrors<Inputs>;
  avgCapacity: number | undefined;
}

export function FSFactorCapacityField({
  fields,
  name,
  value,
  control,
  onBlur,
  errors,
  avgCapacity,
}: IProps) {
  return (
    <Controller
      control={control}
      defaultValue={value}
      name={name}
      rules={{ validate: isFactor }}
      render={({ field }) => (
        <CustomMultipleInputs
          field={field}
          fields={fields}
          onBlur={onBlur}
          errors={errors}
          avgCapacity={avgCapacity}
        />
      )}
    />
  );
}

const CustomMultipleInputs = ({
  field,
  fields,
  onBlur,
  errors,
  avgCapacity,
}: {
  field: ControllerRenderProps<FieldValues, string>;
  fields: EssQuestion['fields'];
  onBlur: () => void;
  errors: FieldErrors<Inputs>;
  avgCapacity: number | undefined;
}) => {
  const [firstValue]: string = field.value.split('##');

  const handleValueChange = (value: string) => {
    field.onChange([value, avgCapacity].join('##'));
  };

  return (
    <>
      <FSTextField
        defaultValue={firstValue}
        type="number"
        label={fields?.[0].title[language]}
        onChange={(e) => handleValueChange(e.target.value)}
        key={field.name}
        onBlur={onBlur}
        error={!!errors[field.name]}
        helperText={errors[field.name]?.message}
      />
      <FSTextField
        defaultValue={avgCapacity}
        disabled
        type="number"
        label={fields?.[1].title[language]}
        key={`${field.name}_average_capacity`}
        error={!!errors[field.name]}
      />
    </>
  );
};
